import React from 'react'
import { Button } from "semantic-ui-react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import MARVEL from "../../common/utils/MarvelUrls";

export class SupportSidebarButtons extends React.Component {
    render() {
        return (
            <div>
                <Button.Group vertical>
                    <Link to={MARVEL.SUPPORT.home}>
                        <Button
                            className="sidebar-buttons"
                            icon="home"
                            content=" Support"
                        />
                    </Link>
                    {this.props.isTxDebugAdmin
                        ? (
                            <Link to={MARVEL.SUPPORT.tx_debug}>
                                <Button
                                    className="sidebar-buttons"
                                    icon="file alternate"
                                    content=" TX-DEBUG LOGS"
                                />
                            </Link>
                        )
                        : null}

                    <Link to={MARVEL.SUPPORT.testcache}>
                        <Button
                            className="sidebar-buttons"
                            icon="table"
                            content=" KYC TESTCACHE"
                        />
                    </Link>
                    <Link to={MARVEL.SUPPORT.kyb_testcache}>
                        <Button
                            className="sidebar-buttons"
                            icon="table"
                            content=" KYB TESTCACHE"
                        />
                    </Link>
                </Button.Group>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isTxDebugAdmin: state.marvel.user.access.accessLevel.isTxDebugAdmin,
})

const mapDispatchToProps = (state) => ({})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SupportSidebarButtons);
